window.addEventListener("load", function() {
    $('.select-center').each(function() {
        const $select = $(this).find('select');
        const $value = $(this).find('.select__value');

        const sync = () => {
            const $selected = $select.find('option:selected');
            const text = ($selected.length ? $selected.text() : '') || '';
            $value.text(text);
        };

        sync();
        $select.on('change', sync);
    });
});